export const BRAND_PROPERTY = {
    GBP_PROPERTY_TYPE: "GBP",
    GBP_VERIFICATION_STATUS: "GBP_VERIFICATION_STATUS",
};

export const GBP_VERIFICATION_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    VERIFIED: 'VERIFIED',
    FAILED: 'FAILED',
    LOGGED_OUT: 'LOGGED_OUT',
}

export const GBP_STEPS = {
    OVERVIEW: 0,
    SEARCH: 1,
    CLAIM: 2,
    VERIFICATION_OPTIONS: 3,
    ENTER_PIN: 4,
    SUCCESS: 5,
};

export const GBP_PROPERTIES = {
    BUSINESS_TITLE: 'title',
    CATEGORY: 'primaryCategoryId',
    PROFILE_DESCRIPTION: 'profile',
    POSTAL_CODE: 'postalCode',
    STATE: 'administrativeArea',
    CITY: 'locality',
    STREET_ADDRESS: 'addressLines',
    CATEGORY: 'primaryCategoryId',
    PHONE_NUMBER: 'primaryPhone',
}

export const LOCATION_DATA_SOURCES = {
    MY_LOCATION: 'MY_LOCATION',
    GBP_EXISTING_LOCATION: 'GBP_EXISTING_LOCATION',
    NEW_LOCATION: 'NEW_LOCATION',
}
export const CREATE_LOCATION = 'CREATE_LOCATION';

export const GBP_USER_LOCATION_VERIFICATION_STATUS = {
    COMPLETED: 'COMPLETED',
}

export const CLAIM_AND_VERIFICATION_PROCESS_SUCCESS_MSG = 'The location claim and verification process completed';
export const CLAIM_AND_VERIFICATION_PROCESS_FAILURE_MSG = 'An issue occurred in the claim and verification process. Please try again';
export const LINK_LOCATION_SUCCESS_MSG = 'Your Google Location has been successfully linked to Sysco Studio account';
export const LINK_LOCATION_FAILURE_MSG = 'A problem occurred. Please try again';
export const VETTED_TOKEN_UPDATE_SUCCESS_MSG = 'Direct Verification Token has been updated successfully';

export const GBP_LOCATIONS_LINK = 'https://business.google.com/locations';
export const GOOGLE_BUSINESS_LINK = 'https://www.google.com/business/';

export const GBP_VERIFICATION_OPTIONS = {
    PHONE_CALL: 'PHONE_CALL',
    SMS: 'SMS',
    EMAIL: 'EMAIL',
};

export const PIN_GENERATION_FAILURE = 'failed-to-generate-pin'
